'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _finance = require('../actions/finance');

var _utils = require('../utils');

var _finance_list = require('../components/finance_list');

var _finance_list2 = _interopRequireDefault(_finance_list);

var _finance_filter = require('../components/finance_filter');

var _finance_filter2 = _interopRequireDefault(_finance_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Finances = _react2.default.createClass({
    displayName: 'Finances',

    propTypes: {
        finances: _react.PropTypes.object.isRequired,
        filter: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!(0, _utils.filterEqual)(nextProps.filter, this.props.filter)) {
            var dispatch = nextProps.dispatch,
                filter = nextProps.filter;

            dispatch((0, _finance.fetchFinancesIfNeeded)(filter));
        }
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _finance.fetchFinancesIfNeeded)(filter));
    },
    onChange: function onChange(name, value) {

        this.props.dispatch((0, _finance.filterFinances)(_defineProperty({}, name, value)));
    },
    onPageChange: function onPageChange(page) {
        // 页码改变
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            filter = _props2.filter;

        dispatch((0, _finance.fetchFinancesIfNeeded)(filter, page));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'finances', className: 'clearfix' },
            _react2.default.createElement(_finance_filter2.default, { onChange: this.onChange, filter: this.props.filter }),
            _react2.default.createElement(_finance_list2.default, { finances: this.props.finances, onChange: this.onPageChange })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var _store$finance = store.finance,
        finances = _store$finance.finances,
        filter = _store$finance.filter;

    return {
        finances: finances,
        filter: filter
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Finances);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/finances.js
// module id = 1318
// module chunks = 0